import { Component } from '@angular/core';


export class SkyDropdownButtonComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-dropdown-button',
  template: `<ng-content></ng-content>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
